export enum ConfigDataset {
    Freewall = "freewall",
    Campaign = "campaign",
    Microsites = "microsites",
    Mappings = "mappings",
    Meta = "meta",
    Profile = "profile"
}
